import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnonymousTokenInterface } from '@shared/interfaces/responses/anonymous-token.interface';
import { Observable, of } from 'rxjs';
import { finalize, map, shareReplay, tap } from 'rxjs/operators';

export const ANONYMOUS_TOKEN_PATH = 'auth/anonymous-token';
export const AUTH_ERROR_HEADER = 'X-Auth-Error';
export const ANONYMOUS_TOKEN_EXPIRED = 'anonymous-token-expired';

@Injectable({
  providedIn: 'root',
})
export class AnonymousTokenService {
  private accessToken = '';
  private pendingTokenRequest$: Observable<string> | null = null;

  constructor(private readonly http: HttpClient) {}

  getToken(): string {
    return this.accessToken;
  }

  ensureToken(): Observable<string> {
    if (this.accessToken) {
      return of(this.accessToken);
    }

    return this.requestSharedToken();
  }

  refreshToken(): Observable<string> {
    this.accessToken = '';

    return this.requestSharedToken();
  }

  private requestSharedToken(): Observable<string> {
    this.pendingTokenRequest$ ??= this.http
      .post<AnonymousTokenInterface>(ANONYMOUS_TOKEN_PATH, {})
      .pipe(
        map(response => response?.accessToken ?? ''),
        tap(token => {
          this.accessToken = token;
        }),
        finalize(() => {
          this.pendingTokenRequest$ = null;
        }),
        shareReplay(1)
      );

    return this.pendingTokenRequest$;
  }
}
